<template>
    <div class="bg-light text-center py-5 mt-5">
        <h4 class="mb-3">Tumblr Widget is a Service of</h4>
        <a href="https://buildyourweb.app">
          <img height="50" :src="bywa_logo" alt="Build Your Web App Logo">
        </a>
    </div>
</template>


<script>
const bywaLogo = require('../assets/images/bywa-logo.png');

export default {
  name: 'BaseBrandedFooter',
  data() {
    return {
      bywa_logo: bywaLogo,
    };
  },
};
</script>
